import { AbstractControl } from '@angular/forms';

export function excludeChar(char: string) {
  return (control: AbstractControl): { excludeChar: string } => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return !(control.value || '').toString().includes(char) ? null : { excludeChar: 'true' };
  };
}
